/******************************************************************************************
 *	Product to Product Name filter
 *******************************************************************************************/
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.productToProductName', []).filter(
    'productToProductName',
    /* @ngInject */
    function(productToProdName) {
      return function(input) {
        return productToProdName.get(input);
      };
    }
  );
})();
